import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailPattern, noWhitespaceInRequiredValidator, mobilePattern } from '../../../shared/constants';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-profile-form',
	templateUrl: './profile-form.component.html',
	styleUrl: './profile-form.component.css'
})
export class ProfileFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	scaleList: any[] = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.moduleForm = this.formBuilder.group({
			name: [null, [Validators.required]],
			description: [null, [Validators.required]],
			age: [0],
			is_videocall: [true],
			scale: [null]
		});
	}

	get f() { return this.moduleForm.controls; }

	ngOnInit(): void {
		this.getScaleList();
		if (this.uId) {
			this.getDetails();
		}
	}

	getScaleList() {
		this.apiService.getAllScaleList().subscribe({
			next: (data: any) => {
				this.scaleList = data;
			}, error: (error) => {
				this.scaleList = [];
				this.toastr.error("Unable to fetch parent scale list.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	deselectById(id: any) {
		var arr: any = this.f.scale.value;
		const index = arr.indexOf(id);
		arr.splice(index, 1);
		arr = [...arr];
		this.f.scale.setValue(arr);
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getProfileDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.f.name.setValue(data.name);
				this.f.age.setValue(data.age);
				this.f.description.setValue(data.description);
				this.f.is_videocall.setValue(data.is_videocall);
				this.f.scale.setValue(data.scale);
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}

		let payload = {
			"name": this.f.name.value,
			"age": this.f.age.value,
			"description": this.f.description.value,
			"is_videocall": this.f.is_videocall.value,
			"scale": this.f.scale.value,
			"id": this.uId
		}
		this.showLoader = true;
		this.apiService.createUpdateProfile(payload).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 409) {
					Swal.fire({
						title: 'Already Exists',
						html: 'Profile with name <strong>' + this.f.name.value + '</strong> already exists. Do you want to restore it?',
						icon: 'question',
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: 'Yes, Restore!',
						cancelButtonText: 'Cancel',
						confirmButtonColor: '#3e4fb1'
					}).then((result) => {
						if (result.value) {
							this.apiService.restoreProfile(error.error.id).subscribe({
								next: (data: any) => {
									this.toastr.success("Restored successfully", 'Success', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
									this.created.emit(data);
									this.clearForm();
								}, error: (error) => {
									this.toastr.error("Something went wrong", 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}
							});
						}
					})
				} else {
					let errorMsg = "Something went wrong.";
					if (error.status == 400) {
						errorMsg = "Profile name already exists";
					}
					this.toastr.error(errorMsg, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true,
					});
				}
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
